import React, { useState } from 'react'
import classNames from 'classnames'
import { DownloadPdfIcon, useErrorService } from '@abroad/components'
import API from '../../utils/API'
import { openLinkInTab } from '../../utils/openLinkInTab'

const PDFDownloadIcon = ({ pdfData, downloadKeySkillHandler }) => {
  const [isDownloadLoading, setIsDownloadLoading] = useState(false)
  const Error = useErrorService()
  const handleDownloadPDF = async (pdfData) => {
    setIsDownloadLoading(true)
    try {
      const { data } = await API.mediaLibrary.getSignedURLForKeySkill(
        pdfData?._id,
      )
      if (data) {
        setIsDownloadLoading(false)
        downloadKeySkillHandler(`${pdfData?.keySkill?.title} (PDF)`)
        setTimeout(() => {
          openLinkInTab(data.url, '_blank')
        })
      } else {
        setIsDownloadLoading(false)
      }
    } catch (e) {
      setIsDownloadLoading(false)
      Error.showError(e)
    }
  }
  return (
    <DownloadPdfIcon
      size={40}
      isLoading={isDownloadLoading}
      disabled={isDownloadLoading}
      onClick={() => handleDownloadPDF(pdfData)}
      className={classNames('d-flex align-self-center', {
        'cursor-pointer': !isDownloadLoading,
      })}
    />
  )
}

export default PDFDownloadIcon
